export default {
  alerts: [],
  alert: null,
  alertsCount: undefined
}
